const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoalLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 349 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.926,39.98c-8.38,0 -13.484,-4.697 -13.765,-13.033l9.987,0c0,3.138 1.608,4.637 3.838,4.637c2.11,0 3.336,-1.319 3.336,-2.978c0,-2.259 -1.226,-3.138 -6.712,-4.538c-5.827,-1.479 -10.61,-5.077 -10.61,-11.914c0,-7.176 5.385,-12.154 13.424,-12.154c8.54,0 13.222,4.698 13.443,12.974l-9.766,0c0,-3.099 -1.668,-4.638 -3.657,-4.638c-1.99,0 -3.497,1.32 -3.497,3.139c0,2.378 1.507,3.038 6.893,4.477c5.988,1.6 10.61,5.797 10.61,11.714c-0.02,7.956 -5.466,12.314 -13.524,12.314Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.032,39.98c-11.052,0 -19.753,-8.995 -19.753,-19.99c0,-10.934 8.721,-19.99 19.753,-19.99c11.032,0 19.753,9.056 19.753,19.99c0.02,10.995 -8.701,19.99 -19.753,19.99Zm0,-30.145c-5.667,0 -9.987,4.638 -9.987,10.155c0,5.517 4.32,10.155 9.987,10.155c5.667,0 9.987,-4.638 9.987,-10.155c0.02,-5.517 -4.32,-10.155 -9.987,-10.155Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.94,39.98l-12.419,0c-5.686,0 -10.308,-4.598 -10.308,-10.255l0,-29.725l9.746,0l0,28.866c0,1.199 0.984,2.179 2.19,2.179l10.771,0l0,8.935l0.02,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.502,39.94l9.666,0.04l-8.199,-32.184c-1.145,-4.578 -4.622,-7.776 -9.364,-7.796c-4.743,-0.02 -8.239,3.159 -9.425,7.716l-8.44,32.124l9.666,0.04l1.326,-5.957l13.484,0.06l1.286,5.957Zm-12.258,-14.193l4.341,-15.752l4.2,15.792l-8.541,-0.04Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.665,
    y: 0,
    width: 3.356,
    height: 39.98,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.229,4.098l0.04,0l2.09,6.417l-4.18,0l2.05,-6.417Zm-1.588,-3.958l-5.928,16.512l3.497,0l1.065,-3.459l5.948,0l1.105,3.459l3.577,0l-5.848,-16.512l-3.416,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.553,
    y: 0.14,
    width: 3.114,
    height: 16.512,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.456,5.358l1.426,0l0,-3.259l3.115,0l0,3.259l1.648,0l0,2.418l-1.648,0l0,5.717c0,0.5 0.221,0.74 1.025,0.74c0.261,0 0.442,-0.02 0.623,-0.06l0,2.479c-0.502,0.06 -0.985,0.14 -1.487,0.14c-2.03,0 -3.255,-0.5 -3.255,-2.939l0,-6.077l-1.427,0l0,-2.418l-0.02,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.23,9.875c-0.1,-1.099 -0.924,-2.419 -2.431,-2.419c-1.628,0 -2.432,1.14 -2.592,2.419l5.023,0Zm-5.023,2.039c0.12,1.319 0.924,2.639 2.592,2.639c0.944,0 1.788,-0.46 2.23,-1.34l3.035,0.24c-0.764,2.299 -2.793,3.519 -5.406,3.519c-3.356,0 -5.687,-2.319 -5.687,-5.937c0,-3.639 2.331,-5.977 5.687,-5.977c3.356,0 5.687,2.318 5.687,5.977l0,0.879l-8.138,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.575,5.358l2.974,-0.001l0,2.179l0.041,0c0.582,-1.599 1.728,-2.478 3.195,-2.478l0.442,0l0,3.078l-0.683,0c-1.608,0 -2.854,0.98 -2.854,2.979l0,5.537l-3.115,0l0,-11.294Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.908,9.775c0,-1.619 -0.965,-2.179 -1.949,-2.179c-1.246,0 -2.03,1.1 -2.03,2.639l0,6.417l-3.115,0l0,-11.295l2.995,0l0,1.48l0.04,0c0.924,-1.36 2.029,-1.779 3.295,-1.779c2.673,0 3.899,1.759 3.899,3.938l0,7.676l-3.115,0l0,-6.897l-0.02,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.889,11.734l-2.592,0.24c-1.427,0.14 -1.909,0.58 -1.909,1.38c0,1.019 0.904,1.319 1.949,1.319c0.965,0 2.552,-0.54 2.552,-1.919l0,-1.02Zm0.121,3.439l-0.04,0c-1.045,1.379 -2.512,1.779 -3.798,1.779c-1.749,0 -3.899,-0.88 -3.899,-3.459c0,-1.199 0.382,-3.198 4.743,-3.478l2.873,-0.18l0,-0.519c0,-1.34 -0.824,-1.999 -2.19,-1.999c-1.286,0 -2.03,0.659 -2.09,1.679l-2.994,0c0.1,-1.739 1.326,-3.958 5.204,-3.958c2.753,0 5.044,1.059 5.044,3.638l0,6.537c0,0.599 0.061,0.979 0.161,1.399l-3.014,0l0,-1.439Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.551,5.358l1.427,0l0,-3.259l3.115,0l0,3.259l1.647,0l0,2.418l-1.647,0l0,5.717c0,0.5 0.221,0.74 1.024,0.74c0.262,0 0.442,-0.02 0.623,-0.06l0,2.479c-0.502,0.06 -0.984,0.14 -1.487,0.14c-2.029,0 -3.255,-0.5 -3.255,-2.939l0,-6.077l-1.427,0l0,-2.418l-0.02,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.79,5.358l3.115,0l0,11.294l-3.115,0l0,-11.294Zm1.568,-5.358c0.924,0 1.808,0.82 1.808,1.82c0,0.959 -0.824,1.859 -1.808,1.859c-1.045,0 -1.809,-0.94 -1.809,-1.82c-0.02,-0.919 0.764,-1.859 1.809,-1.859Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.452,5.357l3.416,0l2.351,7.477l0.041,0l2.351,-7.477l3.416,0l-4.16,11.295l-3.255,0l-4.16,-11.295Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.869,9.875c-0.101,-1.099 -0.925,-2.419 -2.432,-2.419c-1.627,0 -2.431,1.14 -2.592,2.419l5.024,0Zm-5.024,2.039c0.121,1.319 0.924,2.639 2.592,2.639c0.945,0 1.789,-0.46 2.231,-1.34l3.034,0.24c-0.763,2.299 -2.793,3.519 -5.405,3.519c-3.356,0 -5.687,-2.319 -5.687,-5.937c0,-3.639 2.331,-5.977 5.687,-5.977c3.356,0 5.687,2.318 5.687,5.977l0,0.879l-8.139,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.194,5.358l2.994,-0.001l0,2.179l0.04,0c0.583,-1.599 1.729,-2.478 3.196,-2.478l0.422,0l0,3.078l-0.684,0c-1.607,0 -2.853,0.98 -2.853,2.979l0,5.537l-3.115,0l0,-11.294Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.854,23.508l-2.351,11.894l-0.04,0l-2.673,-11.894l-3.497,0l-2.552,11.894l-0.04,0l-2.532,-11.894l-3.456,0l4.2,16.172l3.436,0l2.673,-11.275l0.04,0l2.632,11.275l3.457,0l4.139,-16.172l-3.436,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.439,30.824c-1.648,0 -2.452,1.419 -2.452,3.338c0,1.919 0.804,3.339 2.452,3.339c1.648,0 2.451,-1.419 2.451,-3.338c0,-1.919 -0.803,-3.339 -2.451,-3.339Zm0,9.156c-3.356,0 -5.687,-2.279 -5.687,-5.837c0,-3.559 2.331,-5.838 5.687,-5.838c3.356,0 5.687,2.279 5.687,5.837c0,3.559 -2.331,5.838 -5.687,5.838Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.41,32.943c0,-1.599 -0.965,-2.139 -1.95,-2.139c-1.245,0 -2.029,1.08 -2.029,2.579l0,6.277l-3.115,0l0,-16.172l3.115,0l0,6.557l0.04,0c0.864,-1.34 1.949,-1.739 3.155,-1.739c2.673,0 3.898,1.719 3.898,3.858l0,7.516l-3.114,0l0,-6.737Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.258,
    y: 23.508,
    width: 3.114,
    height: 16.172,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.668,30.985l-1.588,0l0,-2.359l1.588,0l0,-1.44c0,-3.098 1.547,-3.798 4.3,-3.798l0.603,0l0,2.619l-0.864,0c-0.543,0 -0.925,0.28 -0.925,0.9l0,1.719l1.789,0l0,2.359l-1.789,0l0,8.695l-3.114,0l0,-8.695Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.392,34.862l-2.592,0.24c-1.427,0.12 -1.909,0.56 -1.909,1.36c0,0.979 0.904,1.299 1.949,1.299c0.965,0 2.552,-0.54 2.552,-1.879l0,-1.02Zm0.101,3.379c-1.045,1.359 -2.512,1.739 -3.798,1.739c-1.748,0 -3.899,-0.86 -3.899,-3.378c0,-1.18 0.382,-3.139 4.743,-3.399l2.873,-0.18l0,-0.519c0,-1.32 -0.823,-1.959 -2.19,-1.959c-1.286,0 -2.03,0.639 -2.09,1.639l-2.974,0c0.101,-1.699 1.326,-3.878 5.205,-3.878c2.753,0 5.044,1.039 5.044,3.578l0,6.417c0,0.579 0.06,0.959 0.16,1.379l-3.014,0l0,-1.439l-0.06,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.273,32.944c0,-1.6 -0.964,-2.139 -1.949,-2.139c-1.246,0 -2.029,1.079 -2.029,2.578l0,6.277l-3.115,0l0,-16.172l3.115,0l0,6.557l0.04,0c0.864,-1.339 1.949,-1.739 3.155,-1.739c2.672,0 3.898,1.719 3.898,3.858l0,7.516l-3.115,0l0,-6.736Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.161,28.626l2.975,0l0,2.139l0.04,0c0.582,-1.58 1.728,-2.439 3.195,-2.439l0.442,0l0,3.018l-0.683,0c-1.608,0 -2.854,0.96 -2.854,2.919l0,5.417l-3.115,0l0,-11.054Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.857,28.626l1.427,-0.001l0,-3.178l3.115,0l0,3.178l1.648,0l0,2.359l-1.648,0l0,5.597c0,0.5 0.221,0.74 1.025,0.74c0.261,0 0.442,-0.02 0.623,-0.06l0,2.439c-0.503,0.06 -0.985,0.12 -1.487,0.12c-2.03,0 -3.256,-0.5 -3.256,-2.879l0,-5.957l-1.426,0l0,-2.359l-0.021,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.145,32.044c-0.04,-0.92 -0.723,-1.479 -1.909,-1.479c-0.824,0 -1.647,0.319 -1.647,0.979c0,1.979 6.912,0.26 6.912,4.738c0,0.859 -0.482,3.698 -5.064,3.698c-1.547,0 -4.662,-0.48 -4.923,-3.738l3.115,0c0.04,1.079 0.984,1.499 1.929,1.499c0.804,0 1.829,-0.24 1.829,-1.14c0,-1.859 -6.652,-0.179 -6.652,-4.737c0,-1.699 1.326,-3.558 4.602,-3.558c2.853,0 4.742,1.239 4.903,3.658l-3.095,0.08Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.423,28.626l-2.351,7.316l-0.04,0l-2.351,-7.317l-3.416,0l4.159,11.055l3.256,0l4.16,-11.055l-3.417,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.661,33.043c-0.1,-1.079 -0.924,-2.358 -2.431,-2.358c-1.628,0 -2.432,1.119 -2.592,2.358l5.023,0Zm-5.003,1.979c0.12,1.3 0.924,2.579 2.592,2.579c0.944,0 1.788,-0.46 2.23,-1.319l3.035,0.24c-0.764,2.259 -2.793,3.438 -5.406,3.438c-3.356,0 -5.687,-2.279 -5.687,-5.817c0,-3.578 2.331,-5.857 5.687,-5.857c3.356,0 5.687,2.279 5.687,5.857l0,0.859l-8.138,0l0,0.02Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.006,28.626l2.974,0l0,2.139l0.041,0c0.582,-1.58 1.728,-2.439 3.195,-2.439l0.442,0l0,3.018l-0.684,0c-1.607,0 -2.853,0.96 -2.853,2.919l0,5.417l-3.115,0l0,-11.054Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.213,30.945c-1.949,0 -2.853,1.579 -2.853,3.218c0,1.859 1.005,3.318 2.773,3.318c1.829,0 2.813,-1.519 2.813,-3.278c0,-1.659 -0.924,-3.258 -2.733,-3.258Zm-5.847,-7.437l3.115,0l0,6.617l0.04,0c1.045,-1.359 2.09,-1.799 3.516,-1.799c3.195,0 5.145,2.739 5.145,5.817c0,3.078 -2.09,5.857 -5.185,5.857c-1.427,0 -2.733,-0.54 -3.617,-1.859l-0.04,0l0,1.539l-2.974,0l0,-16.172Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.405,34.862l-2.592,0.24c-1.427,0.12 -1.909,0.56 -1.909,1.36c0,0.979 0.904,1.299 1.949,1.299c0.965,0 2.552,-0.54 2.552,-1.879l0,-1.02Zm0.081,3.379c-1.045,1.359 -2.512,1.739 -3.798,1.739c-1.748,0 -3.899,-0.86 -3.899,-3.378c0,-1.18 0.382,-3.139 4.743,-3.399l2.873,-0.18l0,-0.519c0,-1.32 -0.823,-1.959 -2.19,-1.959c-1.286,0 -2.03,0.639 -2.09,1.639l-2.974,0c0.101,-1.699 1.326,-3.878 5.205,-3.878c2.753,0 5.044,1.039 5.044,3.578l0,6.417c0,0.579 0.06,0.959 0.16,1.379l-3.014,0l0,-1.439l-0.06,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.266,32.943c0,-1.599 -0.964,-2.139 -1.949,-2.139c-1.246,0 -2.029,1.08 -2.029,2.579l0,6.277l-3.115,0l0,-11.054l2.974,0l0,1.439l0.04,0c0.924,-1.339 2.03,-1.739 3.296,-1.739c2.672,0 3.898,1.719 3.898,3.858l0,7.516l-3.115,0l0,-6.737Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.539,30.945c-1.788,0 -2.732,1.599 -2.732,3.278c0,1.739 0.964,3.278 2.813,3.278c1.768,0 2.773,-1.459 2.773,-3.318c0,-1.659 -0.904,-3.238 -2.854,-3.238Zm2.874,7.176l-0.04,0c-0.884,1.319 -2.191,1.859 -3.617,1.859c-3.095,0 -5.185,-2.779 -5.185,-5.857c0,-3.079 1.949,-5.817 5.145,-5.817c1.426,0 2.491,0.46 3.516,1.799l0.04,0l0,-6.617l3.115,0l0,16.172l-2.994,0l0,-1.539l0.02,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoalLogoWhite);
export default __webpack_public_path__ + "static/media/soal-logo_white.8210bd6e368936a57a0ba748391db527.svg";
export { ForwardRef as ReactComponent };